module.exports = __webpack_public_path__ + "assets/img/ceremonyBg.17acd4a7.png";